import * as React from "react";
import { Box, Typography } from "@mui/material";
import { CCard } from "../../components/common/CCard";

export default function DeliveryType() {
  return (
    <Box>
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: "24px",
          color: "var(--neutral-black)",
          textAlign: "left",
          lineHeight: "133%",
          mb: 2,
        }}
      >
        Delivery Method
      </Typography>
      <CCard sx={{ p: 2.5 }}>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            color: "var(--neutral-black)",
            lineHeight: "150%",
          }}
        >
          Home Delivery
        </Typography>
        <Typography
          sx={{
            mt: 0.5,
            fontSize: "14px",
            color: "var(--neutral-700)",
            lineHeight: "150%",
          }}
        >
          We deliver across India based on your pincode.
        </Typography>
      </CCard>
    </Box>
  );
}
